import { Plus, Trash2 } from "lucide-react";
import { ADMIN } from "@/constants/testIds";

// Fix D (2026-09-01): lista editable de destinatarios de notificación, compartida entre
// Clientes.jsx (destinatarios del cliente) y UnidadForm.jsx (destinatarios propios de la unidad).

export function destinatarioVacio() {
  return { nombre: "", telefono: "", email: "", consentimiento: false, consentimiento_origen: "" };
}

export function destinatarioDesdeApi(d) {
  return {
    nombre: d.nombre || "",
    telefono: d.telefono || "",
    email: d.email || "",
    consentimiento: Boolean(d.consentimiento?.otorgado),
    consentimiento_origen: d.consentimiento?.origen || "",
  };
}

export function destinatariosParaGuardar(destinatarios) {
  return destinatarios
    .filter((d) => d.telefono.trim() || d.email.trim())
    .map((d) => ({
      nombre: d.nombre.trim() || null,
      telefono: d.telefono.trim() || null,
      email: d.email.trim() || null,
      consentimiento: d.telefono.trim() ? d.consentimiento : false,
      consentimiento_origen: d.consentimiento_origen.trim() || null,
    }));
}

export function DestinatariosEditor({ destinatarios, onChange, max }) {
  const actualizarFila = (i, campo, valor) => {
    onChange(destinatarios.map((d, idx) => (idx === i ? { ...d, [campo]: valor } : d)));
  };
  const quitarFila = (i) => onChange(destinatarios.filter((_, idx) => idx !== i));
  const agregarFila = () => onChange([...destinatarios, destinatarioVacio()]);

  return (
    <div className="flex flex-col gap-3">
      {destinatarios.length === 0 && (
        <p className="text-sm text-[var(--tc-text-secondary)]">Todavía no hay destinatarios cargados.</p>
      )}
      {destinatarios.map((d, i) => (
        <div key={i} data-testid={ADMIN.destinatarioRow} className="rounded-[var(--tc-radius)] border border-[var(--tc-border)] bg-white p-3">
          <div className="flex items-start justify-between gap-2">
            <div className="grid flex-1 gap-2.5 sm:grid-cols-2">
              <input
                data-testid={ADMIN.destinatarioNombre}
                value={d.nombre}
                onChange={(e) => actualizarFila(i, "nombre", e.target.value)}
                placeholder="Etiqueta (ej: Vendedor, Comex)"
                className="w-full rounded-[var(--tc-radius)] border border-[var(--tc-border)] px-3 py-2 text-sm outline-none focus:border-[var(--tc-accent)] sm:col-span-2"
              />
              <input
                data-testid={ADMIN.destinatarioTelefono}
                value={d.telefono}
                onChange={(e) => actualizarFila(i, "telefono", e.target.value)}
                placeholder="+573001234567"
                className="w-full rounded-[var(--tc-radius)] border border-[var(--tc-border)] px-3 py-2 text-sm outline-none focus:border-[var(--tc-accent)]"
              />
              <input
                data-testid={ADMIN.destinatarioEmail}
                type="email"
                value={d.email}
                onChange={(e) => actualizarFila(i, "email", e.target.value)}
                placeholder="contacto@email.com"
                className="w-full rounded-[var(--tc-radius)] border border-[var(--tc-border)] px-3 py-2 text-sm outline-none focus:border-[var(--tc-accent)]"
              />
              {d.telefono.trim() && (
                <>
                  <label className="flex items-center gap-2 text-sm text-[var(--tc-text)] sm:col-span-2">
                    <input
                      data-testid={ADMIN.destinatarioConsentimiento}
                      type="checkbox"
                      checked={d.consentimiento}
                      onChange={(e) => actualizarFila(i, "consentimiento", e.target.checked)}
                      className="h-4 w-4 accent-[var(--tc-accent)]"
                    />
                    Tengo el consentimiento del destinatario para escribirle por WhatsApp
                  </label>
                  <input
                    data-testid={ADMIN.destinatarioOrigen}
                    value={d.consentimiento_origen}
                    onChange={(e) => actualizarFila(i, "consentimiento_origen", e.target.value)}
                    placeholder="Origen del consentimiento (ej: contrato)"
                    className="w-full rounded-[var(--tc-radius)] border border-[var(--tc-border)] px-3 py-2 text-sm outline-none focus:border-[var(--tc-accent)] sm:col-span-2"
                  />
                </>
              )}
            </div>
            <button
              type="button"
              data-testid={ADMIN.destinatarioRemoveButton}
              onClick={() => quitarFila(i)}
              className="rounded-[var(--tc-radius)] p-1.5 text-[var(--tc-text-secondary)] hover:bg-red-50 hover:text-red-600"
            >
              <Trash2 size={15} />
            </button>
          </div>
        </div>
      ))}
      {destinatarios.length < max && (
        <button
          type="button"
          data-testid={ADMIN.destinatarioAddButton}
          onClick={agregarFila}
          className="inline-flex items-center gap-1.5 self-start rounded-[var(--tc-radius)] border border-dashed border-[var(--tc-border)] px-3 py-2 text-sm font-medium text-[var(--tc-accent)] hover:bg-[var(--tc-accent-soft)]"
        >
          <Plus size={14} /> Agregar destinatario
        </button>
      )}
      <p data-testid={ADMIN.destinatariosWhatsappGroupNote} className="text-xs text-[var(--tc-text-secondary)]">
        Los avisos por WhatsApp se envían a cada número por separado. WhatsApp no permite enviar mensajes automáticos a grupos.
      </p>
    </div>
  );
}
